import backendAxios from '../utils/backendAxios';
import { sendMessage } from './chat';

// Create a customized quote (Cotización Personalizada) and send it as a message in the chat
export const createQuoteAndSendMessage = (chatId, quoteData) => async dispatch => {
  try {
    // 1. Post quote data to /api/quote
    const res = await backendAxios.post('/api/quote', quoteData);
    const quote = res.data;
    
    // 2. Send message of type 'quote' referencing the quote._id
    const content = `Te he enviado una cotización: ${quote.concepto}`;
    await dispatch(sendMessage(chatId, content, quote._id, 'quote'));
    
    return quote;
  } catch (err) {
    console.error('Error al crear y enviar cotización:', err.response?.data || err.message);
    throw err;
  }
};

// Update quote status (aceptada or declinada)
export const updateQuoteStatus = (quoteId, status, chatId = null) => async dispatch => {
  try {
    const res = await backendAxios.patch(`/api/quote/${quoteId}/status`, { status });
    const quote = res.data;

    // Send a message in the chat to notify the other participant
    if (chatId) {
      const statusText = status === 'aceptada' ? 'aceptado' : 'declinado';
      const content = `He ${statusText} tu cotización para: ${quote.concepto}`;
      await dispatch(sendMessage(chatId, content));
    }
    
    return quote;
  } catch (err) {
    console.error('Error al actualizar estado de cotización:', err.response?.data || err.message);
    throw err;
  }
};

// Get quote detail by ID
export const getQuoteDetail = (quoteId) => async () => {
  try {
    const res = await backendAxios.get(`/api/quote/${quoteId}`);
    return res.data;
  } catch (err) {
    console.error('Error al obtener detalle de cotización:', err.response?.data || err.message);
    throw err;
  }
};

// Backwards compatibility actions (using backendAxios)
export const addQuote = (formData) => async dispatch => {
  try {
    const res = await backendAxios.post('/api/quote', formData);
    return res.data;
  } catch (err) {
    console.error(err);
    return "errores";
  }
};

export const getQuote = id => async () => {
  try {
    const res = await backendAxios.get(`/api/quote/${id}`);
    return res.data;
  } catch (err) {
    console.error(err);
  }
};